import { useState } from 'react';

import DefaultLogo from '../defaultLogo/DefaultLogo';
import { Arrow, Image, Menu, MenuItem, Wrapper } from './AccountMenu.styles';

export interface AccountProps {
  image?: string;
  options?: { text: string; onClick: () => void }[];
}

const AccountMenu = ({ image, options }: AccountProps): JSX.Element => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  return (
    <Wrapper onClick={() => setIsMenuOpen(!isMenuOpen)}>
      {image ? <Image src={image} alt="Company" /> : <DefaultLogo size="lg" />}
      <Arrow isMenuOpen={isMenuOpen} />
      {isMenuOpen && (
        <Menu>
          {options.map((option) => (
            <MenuItem
              onClick={option.onClick}
              key={option.onClick}
              suppressHydrationWarning
            >
              {option.text}
            </MenuItem>
          ))}
        </Menu>
      )}
    </Wrapper>
  );
};

export default AccountMenu;
